var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.exam
    ? _c(
        "div",
        {
          staticClass: "exam-final-screen",
          attrs: { "justify-content-center": "", wrap: "" },
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-list",
                { staticClass: "report-list" },
                [
                  _vm._l(_vm.groupQuestions, function (item, index) {
                    return [
                      _c("ExamResultQuestionGroupList", {
                        key: index + "group",
                        attrs: {
                          item: item,
                          questionNumber: _vm.getQuestionNumber(item),
                          padding: true,
                          exam: _vm.exam,
                          "user-exam": _vm.userExam,
                          examQScoreHistory: _vm.examQScoreHistory,
                        },
                      }),
                      _vm._v(" "),
                      index + 1 < _vm.groupQuestions.length
                        ? _c("v-divider", { key: index + "group_divider" })
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }